import React from 'react';
import "../../../styles/ChaatsParadice.css";

function ChaatsParadice(props) {
  return (
    <div id="ChaatsParadise">
        <svg class="CHAAT_22_PCRectangle_743">
            <rect id="CHAAT_22_PCRectangle_743" rx="0" ry="0" x="0" y="0" width="1366" height="1400">
            </rect>
        </svg>
        <div id="CHAAT_22_PCGroup_108">
            <svg class="CHAAT_22_PCRectangle_1">
                <rect id="CHAAT_22_PCRectangle_1" rx="0" ry="0" x="0" y="0" width="1366" height="700">
                </rect>
            </svg>
            <img id="CHAAT_22_PCpexels-vinit-jain-16171917" src="./Themes/ChaatsParadice/pexels-vinit-jain-16171917.png" srcset="./Themes/ChaatsParadice/pexels-vinit-jain-16171917.png 1x" />
                
            <div id="CHAAT_22_PCTaste_the_Best_Right_Now">
                <span>Taste the Best Right Now!</span>
            </div>
            <div id="CHAAT_22_PCAny_succesfull_career_starts_w">
                <span>Any succesfull career starts with good education</span>
            </div>
            <img id="CHAAT_22_PClogo" src={props.data.imageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(props.data.imageUrl.split('/')[5]):"./Themes/ChaatsParadice/logo.png"} />
                
        </div>
        <div id="CHAAT_22_PCName">
            <span>{props.data.businessName}</span>
        </div>
        <div id="CHAAT_22_PCGroup_15064">
            <div id="CHAAT_22_PCCard_03_website_14_web_pc">
                <div id="CHAAT_22_PCScroll_Group_12">
                    <div id="CHAAT_22_PCintro_lbl_14_web_pc">
                        <span>{props.data.principles}</span>
                    </div>
                </div>
                <div id="CHAAT_22_PCprinciples_lbl_14_web_pc">
                    <span>Principles</span>
                </div>
                <svg class="CHAAT_22_PCIcon_top_14_web_pc" viewBox="1.03 0 23.555 4.195">
                    <path id="CHAAT_22_PCIcon_top_14_web_pc" d="M 4.82841968536377 0 L 1.029673933982849 4.194554328918457 L 20.77211761474609 4.194554328918457 L 24.58427429199219 0 L 4.82841968536377 0 Z">
                    </path>
                </svg>
                <img id="CHAAT_22_PCkevin-mu14_web_pc" src="./Themes/ChaatsParadice/kevin-mu14_web_pc.png" srcset="./Themes/ChaatsParadice/kevin-mu14_web_pc.png 1x" />
                    
            </div>
            <div id="CHAAT_22_PCCard_02_website_14_web_pc">
                <div id="CHAAT_22_PCScroll_Group_11">
                    <div id="CHAAT_22_PCintro_2_14_web_pc">
                        <span>{props.data.mission}</span>
                    </div>
                </div>
                <div id="CHAAT_22_PCmission_lbl_we14_web_pc">
                    <span>Mission</span>
                </div>
                <img id="CHAAT_22_PCzden14_web_pc" src="./Themes/ChaatsParadice/zden14_web_pc.png" srcset="./Themes/ChaatsParadice/zden14_web_pc.png 1x" />
                    
            </div>
            <div id="CHAAT_22_PCCard_01_website_14_web_pc">
                <div id="CHAAT_22_PCScroll_Group_10">
                    <div id="CHAAT_22_PCintro_w14_web_pc">
                        <span>{props.data.vision}</span>
                    </div>
                </div>
                <div id="CHAAT_22_PCVision_14_web_pc">
                    <span>Vision</span>
                </div>
                <img id="CHAAT_22_PCaarn-giri-3lGi014_web_pc" src="./Themes/ChaatsParadice/aarn-giri-3lGi014_web_pc.png" srcset="./Themes/ChaatsParadice/aarn-giri-3lGi014_web_pc.png 1x" />
                    
            </div>
        </div>
        <div id="CHAAT_22_PCOur_Chaats">
            <span>Our Chaats</span>
        </div>
        <div id="CHAAT_22_PCScroll_Group_78">
	{props.offeringsData.map((off,idx)=>(
            <div id="CHAAT_22_PCGroup_14872">
                <svg class="CHAAT_22_PCRectangle_688">
                    <rect id="CHAAT_22_PCRectangle_688" rx="10" ry="10" x="0" y="0" width="220" height="328">
                    </rect>
                </svg>
                <img id="CHAAT_22_PCpexels-shahbaz-ansari-13063300" src={off.defaultOfferingsImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(off.defaultOfferingsImageUrl.split('/')[5]):"./Themes/ChaatsParadice/pexels-shahbaz-ansari-13063300.png"} />
                    
                <div id="CHAAT_22_PCPani_Puri">
                    <span>{off.offeringTitle}</span>
                </div>
            </div>))}
        </div>
        <div id="CHAAT_22_PCsocials_grp_shadow_space_websi">
		{props.data.linkedInUrl?
            <div title="LinkedIn" id="CHAAT_22_PClinked_in_grp_shadow_space_web">
                <svg class="CHAAT_22_PCmed_shadow_space_website_7">
                    <ellipse id="CHAAT_22_PCmed_shadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                    </ellipse>
                </svg>
                <div id="CHAAT_22_PClinked_in_shadow_space_website">
				<a href={props.data.linkedInUrl} target="_blank">
                    <svg class="CHAAT_22_PCn_website_7_layout_" viewBox="-15.255 0 15.439 14.566">
                        <path id="CHAAT_22_PCn_website_7_layout_" d="M -5.594671249389648 3.814697265625e-06 C -8.203055381774902 3.814697265625e-06 -9.837490081787109 1.412798166275024 -10.13955497741699 2.402577638626099 L -10.13955497741699 0.1386871188879013 L -15.2549991607666 0.1386871188879013 C -15.18850803375244 1.3406081199646 -15.2549991607666 14.56553649902344 -15.2549991607666 14.56553649902344 L -10.13955497741699 14.56553649902344 L -10.13955497741699 6.758750915527344 C -10.13955497741699 6.324968814849854 -10.16045379638672 5.891188621520996 -10.02873420715332 5.579627513885498 C -9.676643371582031 4.71206521987915 -8.921167373657227 3.811574220657349 -7.562833309173584 3.811574220657349 C -5.78718090057373 3.811574220657349 -4.979146957397461 5.145845413208008 -4.979146957397461 7.100076198577881 L -4.979146957397461 14.56553649902344 L 0.1837937831878662 14.56553649902344 L 0.1837937831878662 6.543442726135254 C 0.1837937831878662 2.075184345245361 -2.358731746673584 3.814697265625e-06 -5.594671249389648 3.814697265625e-06">
                        </path>
                    </svg>
                </a>
                    <svg class="CHAAT_22_PClinked_in_i_shadow_space_websi" viewBox="0.931 -22.783 4.553 14.427">
                        <path id="CHAAT_22_PClinked_in_i_shadow_space_websi" d="M 0.9310000538825989 -8.35551643371582 L 5.484113693237305 -8.35551643371582 L 5.484113693237305 -22.78300476074219 L 0.9310000538825989 -22.78300476074219 L 0.9310000538825989 -8.35551643371582 Z">
                        </path>
                    </svg>
                    <svg class="CHAAT_22_PCtop_dot_i_shadow_space_website" viewBox="-4.392 0 5.527 5.006">
                        <path id="CHAAT_22_PCtop_dot_i_shadow_space_website" d="M -1.610737085342407 0 C -3.292033195495605 0 -4.392000198364258 1.079702377319336 -4.392000198364258 2.505163192749023 C -4.392000198364258 3.902759790420532 -3.323695659637451 5.005893707275391 -1.675329208374023 5.005893707275391 L -1.642399907112122 5.005893707275391 C 0.06929254531860352 5.005893707275391 1.135063052177429 3.898960590362549 1.135063052177429 2.50072979927063 C 1.10213315486908 1.077169299125671 0.06929254531860352 0 -1.610737085342407 0">
                        </path>
                    </svg>
                </div>
            </div>:""}
			{props.data.instagramUrl?	
            <div title="Instagram" id="CHAAT_22_PCInsta_grp_shadow_space_website">
                <svg class="CHAAT_22_PCshadow_space_website_7">
                    <ellipse id="CHAAT_22_PCshadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
                    </ellipse>
                </svg>
				<a href={props.data.instagramUrl} target="_blank">
                <img id="CHAAT_22_PCinstagramshadow_space_website_" src="./Themes/ChaatsParadice/instagramshadow_space_website_.png" srcset="./Themes/ChaatsParadice/instagramshadow_space_website_.png 1x" />
                    
                </a>
            </div>:""}
			{props.data.whatsAppNumber?
            <div title="WhatsApp" id="CHAAT_22_PCwhatsapp_grp_shadow_space_webs">
                <svg class="CHAAT_22_PCmed_shadow_space_website_7_br">
                    <ellipse id="CHAAT_22_PCmed_shadow_space_website_7_br" rx="24" ry="24" cx="24" cy="24">
                    </ellipse>
                </svg>
                <a href={"https://api.whatsapp.com/send?phone="+props.data.whatsAppNumber.substring(props.data.whatsAppNumber.length-10)} target="_blank">
				<img id="CHAAT_22_PCwhatsapp_lbl_shadow_space_webs" src="./Themes/ChaatsParadice/whatsapp_lbl_shadow_space_webs.png" srcset="./Themes/ChaatsParadice/whatsapp_lbl_shadow_space_webs.png 1x" />
                    </a>
            </div>:""}
        </div>
        <div id="CHAAT_22_PCn_234567890_mobile_number_shad">
            <span>{props.data.businessPhone}</span>
        </div>
        <div id="CHAAT_22_PCaffanghanioperatelive_email_sh">
            <span>{props.data.businessEmail}</span>
        </div>
        <div id="CHAAT_22_PCaddress_med_shadow_space_websi">
            <span>{props.data.businessAddress}</span>
        </div>
        <img id="CHAAT_22_PClocation_img_shadow_space_webs" src="./Themes/ChaatsParadice/location_img_shadow_space_webs.png" srcset="./Themes/ChaatsParadice/location_img_shadow_space_webs.png 1x" />
            
        <img id="CHAAT_22_PCemail_address_shadow_space_web" src="./Themes/ChaatsParadice/email_address_shadow_space_web.png" srcset="./Themes/ChaatsParadice/email_address_shadow_space_web.png 1x" />
            
        <img id="CHAAT_22_PCphone_number_shadow_space_webs" src="./Themes/ChaatsParadice/phone_number_shadow_space_webs.png" srcset="./Themes/ChaatsParadice/phone_number_shadow_space_webs.png 1x" />
            
        <div id="CHAAT_22_PCn_Copyright_Operate_Live_OPC_P">
            <span>© Copyright Operate Live (OPC) Private Limited. All Rights Reserved</span>
        </div>
        <iframe src={"https://maps.google.com/maps?width=100%25&height=600&hl=en&q="+((props.data.mapLatitude && (props.data.mapLatitude.toString()).length > 0)?props.data.mapLatitude.toString():"13.027696798394835")+","+((props.data.mapLongitude && (props.data.mapLongitude.toString()).length > 0)?props.data.mapLongitude.toString():"77.61844225211368")+"&t=&z=20&ie=UTF8&iwloc=B&output=embed&embedded=true;"} width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="CHAAT_22_PCRectangle_744">
            <rect id="CHAAT_22_PCRectangle_744" rx="0" ry="0" x="0" y="0" width="480" height="270">
            </rect>
        </iframe>
        <svg class="CHAAT_22_PCLine_27" viewBox="0 0 1281 1">
            <path id="CHAAT_22_PCLine_27" d="M 0 0 L 1281 0">
            </path>
        </svg>
    </div>
  )
}

export default ChaatsParadice